import { TGetInvoicesListResponseItem, TGpsrProductType } from 'redux/reducers/gpsr/types';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';

type TGetInvoicesListResponseItemWithId = TGetInvoicesListResponseItem & { id: number };

export const gpsrInvoiceListTableStructure: TTableStructure<
	keyof TGetInvoicesListResponseItemWithId
>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TGetInvoicesListResponseItemWithId,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Invoice ID',
		selector: 'invoiceId' as keyof TGetInvoicesListResponseItemWithId,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Invoice Number',
		selector: 'invoiceNumber' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		searchable: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'EM Name',
		selector: 'emName' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 4,
	},
	{
		name: 'Date Time',
		selector: 'dateTime' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Amount',
		selector: 'amount' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,

		colSpan: 1,
	},
	{
		name: 'Payment Status',
		selector: 'paymentStatus' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['paid', 'paid'],
			['pending', 'pending'],
			['partially_paid', 'partially paid'],
		],
		colors: [
			['paid', 'success.light'],
			['pending', 'warning.light'],
			['partially_paid', 'info.light'],
		],
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
];
